import React from 'react';
import { PointMascot } from '../../PointMascot/PointMascot';

export function Loader() {
  return (
    <div className="fixed inset-0 z-20 bg-white bg-opacity-40 flex flex-col items-center justify-center backdrop-blur-md">
      <style>{`
        @keyframes peekBob {
          0%, 100% { transform: translateY(0); }
          50%      { transform: translateY(-7px); }
        }
        @keyframes saludoI {
          0%, 100% { transform: rotate(0deg); }
          50%      { transform: rotate(16deg); }
        }
        @keyframes saludoD {
          0%, 100% { transform: rotate(0deg); }
          50%      { transform: rotate(-16deg); }
        }
        .pose-peek { animation: peekBob 2.6s ease-in-out infinite; }
        .pose-peek svg .brazo-i { animation: saludoI 2.6s ease-in-out infinite; transform-origin: center; }
        .pose-peek svg .brazo-d { animation: saludoD 2.6s ease-in-out infinite; transform-origin: center; }
      `}</style>
      
      <PointMascot pose="peek" size={130} />
      
      <div className="mt-6 text-2xl font-bold tracking-[0.2em] text-[#2D3689] animate-pulse">
        CARGANDO...
      </div>
    </div>
  );
}
